import { Flower2, Truck, Heart, MapPin } from "lucide-react";

// Angelic Flower Co. — Islington · Botanical, refined
export default function AngelicAfter({ b }) {
  return (
    <div className="bg-[#F4F7F4] text-[#2D4A22]">
      <div className="px-6 md:px-10 py-4 flex items-center justify-between border-b border-[#2D4A22]/10">
        <div className="flex items-center gap-2 font-playfair italic text-2xl">
          <Flower2 className="w-5 h-5 text-[#E8B4B8]" />
          Angelic
        </div>
        <nav className="hidden md:flex gap-6 text-[11px] tracking-[0.2em] uppercase text-[#2D4A22]/70">
          <span>Shop</span><span>Subscriptions</span><span>Weddings</span><span>Sympathy</span>
        </nav>
        <button className="bg-[#E8B4B8] text-[#2D4A22] px-4 py-2 text-[11px] uppercase tracking-[0.2em] font-medium">Bag · 0</button>
      </div>

      {/* Hero */}
      <div className="grid grid-cols-1 md:grid-cols-12 px-6 md:px-10 py-16 md:py-24 gap-10 items-center">
        <div className="md:col-span-7">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#E8B4B8] mb-6">Florist on Islington High Street · N1</p>
          <h1 className="font-playfair text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
            <span className="italic">Five-star</span> stems,<br/>
            cut this morning,<br/>
            <span className="italic text-[#E8B4B8]">delivered by lunch.</span>
          </h1>
          <p className="mt-8 max-w-lg text-lg leading-relaxed text-[#2D4A22]/80">
            Seasonal British blooms, foraged foliage, and a quiet stand outside 80 Islington High Street.
            Now finally — bookable, deliverable, ours online.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <a className="bg-[#2D4A22] text-[#F4F7F4] px-6 py-4 text-xs uppercase tracking-[0.2em]">Shop bouquets</a>
            <a className="border border-[#2D4A22] px-6 py-4 text-xs uppercase tracking-[0.2em]">Subscribe — from £24/mo</a>
          </div>
        </div>
        <div className="md:col-span-5 relative">
          <div className="aspect-square bg-cover bg-center" style={{ backgroundImage: "url(https://images.pexels.com/photos/5566818/pexels-photo-5566818.jpeg)" }} />
          <div className="absolute -bottom-4 -left-4 bg-[#E8B4B8] text-[#2D4A22] p-4 font-playfair italic text-xl shadow-lg">
            {b.rating} ★ <span className="text-xs not-italic font-sans tracking-widest uppercase ml-1">{b.reviews} reviews</span>
          </div>
        </div>
      </div>

      {/* Bouquet grid */}
      <div className="px-6 md:px-10 py-16 border-t border-[#2D4A22]/10">
        <div className="flex items-end justify-between mb-10">
          <h2 className="font-playfair text-4xl md:text-5xl">This week's bouquets</h2>
          <span className="text-xs uppercase tracking-[0.3em] text-[#2D4A22]/60">Wk. 06 — Feb 2026</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            ["The Angel", "£34", "ranunculus · tulip · narcissi"],
            ["Upper Street", "£48", "garden rose · eucalyptus"],
            ["Highbury Fields", "£62", "peony · sweet pea · mint"],
            ["Sympathy White", "£55", "lily · stock · lisianthus"],
          ].map(([n, p, d], i) => (
            <div key={i} className="group">
              <div className="aspect-[3/4] bg-[#E8B4B8]/20 mb-3 relative overflow-hidden">
                <div className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-700"
                  style={{ backgroundImage: `url(https://images.pexels.com/photos/5566818/pexels-photo-5566818.jpeg)`, filter: `hue-rotate(${i * 30}deg)` }} />
              </div>
              <div className="flex justify-between items-baseline">
                <span className="font-playfair italic text-2xl">{n}</span>
                <span className="text-sm">{p}</span>
              </div>
              <p className="text-xs text-[#2D4A22]/60 mt-1">{d}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Footer/Visit */}
      <div className="px-6 md:px-10 py-16 bg-[#2D4A22] text-[#F4F7F4] grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <Truck className="w-6 h-6 text-[#E8B4B8] mb-3" />
          <h3 className="font-playfair text-2xl italic mb-2">Same-day in N1, EC1, N5</h3>
          <p className="text-sm text-[#F4F7F4]/70">Order by 1pm. £6 delivery, free over £45.</p>
        </div>
        <div>
          <Heart className="w-6 h-6 text-[#E8B4B8] mb-3" />
          <h3 className="font-playfair text-2xl italic mb-2">Weddings & funerals</h3>
          <p className="text-sm text-[#F4F7F4]/70">Bespoke consultation, North London-wide.</p>
        </div>
        <div>
          <MapPin className="w-6 h-6 text-[#E8B4B8] mb-3" />
          <h3 className="font-playfair text-2xl italic mb-2">Find the stand</h3>
          <p className="text-sm text-[#F4F7F4]/70">{b.address}</p>
        </div>
      </div>
    </div>
  );
}
